<template>
  <div class="view">
    <div class="header boxItem">
      <Nav ref="nav"/>
      <!-- <img class="title-banner" @click="goTryPro" v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/banner.png'" alt=""> -->
      <Banner @goTake="goTaking"/>
    </div>
    <div class="content">
      <div class="boxItem introduction">
        <img class="boxItem-bj" v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/companyInfoBj.png'" alt="">
        <div class="content-title">
          <span class="title-ch">公司简介</span>
          <span class="title-en">Company profile</span>
          <div class="title-dot">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <ul class="company-img">
          <li><img v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/company2.png'"></li>
          <li><img v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/company1.png'"></li>
          <li><img v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/company3.png'"></li>
        </ul>
        <ul class="company-text">
          <li>深圳市前海尚云技术有限公司于2017年3月成立于广东省深圳市前海贸易区，注册资本1000万。核心成员由来自中国华融、工商银行、腾讯、华为等知名机构及互联网资深人士组成。</li>
          <li>尚云深耕于金融及互联网行业多年，成立以来，通过资源优化、技术赋能，为企业实现利用已有资源再创价值，帮助企业增收，实现利益最大化。</li>
          <li></li>
        </ul>
      </div>
      <div class="database">
        <img class="boxItem-bj" v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/databasebBj.png'" alt="">
        <div class="database-ch">资源整合 | 共创价值 | 共享收益</div>
        <div class="database-en">Resource integration | value creation | revenue sharing</div>
      </div>
      <div class="boxItem service">
        <div class="content-title">
          <span class="title-ch">服务内容</span>
          <span class="title-en">service content</span>
          <div class="title-dot">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="card-list">
            <div class="card-item">
              <div class="card-img">
                <img v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/companyManageBj.png'" alt="">
              </div>
              <div class="card-text">充分了解企业客户，输出优化方案，整合三方资源，提升企业价值。</div>
            </div>
            <div class="card-item">
              <div class="card-img">
                <img v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/plan.png'" alt="">
              </div>
              <div class="card-text">通过设计与实施技术方案，帮助客户解决业务流程、数据和技术问题。</div>
            </div>
            <div class="card-item">
              <div class="card-img">
                <img v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/softDev.png'" alt="">
              </div>
              <div class="card-text">提供APP、网页、系统定制开发，技术大拿、行业精英为您的企业量身定制。</div>
            </div>
            <div class="card-item">
              <div class="card-img">
                <img v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/companyService.png'" alt="">
              </div>
              <div class="card-text">提供不同行业数字化解决方案，助力企业一站式上云，加速企业线上服务升级。</div>
            </div>
          </div> 
        </div>
      </div>
      <div class="boxItem contactUs">
        <img class="boxItem-bj" v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/phoneBj.png'" alt="">
        <div class="content-title">
          <span class="title-ch" style="color:#fff">联系我们</span>
          <span class="title-en" style="color:#fff">contact us</span>
          <div class="title-dot">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="contact-view">
          <ul>
            <li><img src="/static/adress.png" alt=""></li>
            <li>公司地址</li>
            <li></li>
            <li>深圳市南山区科技园科兴科学园B3单元15层1503</li>
          </ul>
          <ul>
            <li><img src="/static/adress.png" alt=""></li>
            <li>联系方式</li>
            <li></li>
            <li>0755-26651443</li>
          </ul>
          <ul>
            <li><img src="/static/adress.png" alt=""></li>
            <li>邮政编码</li>
            <li></li>
            <li>518067</li>
          </ul>
        </div>
        <Map />
      </div>
      <!-- <img class="boxItem boxTry" v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/introduce.png'" alt="">
      <img class="boxItem" v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/step.png'" alt="">
      <img v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/partners.png'" alt="">
      <img class="boxItem" v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/contact.png'" alt=""> -->
    </div>
    <div class="footer">
      <div class="record-number">深圳市前海尚云技术有限公司版权所有©  <a style="color:#fff" href="https://beian.miit.gov.cn">粤ICP备17071874号</a></div>
      <!-- <img v-lazy="'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/record.png'" alt=""> -->
    </div>
  </div>
</template>

<script>
// import Nav from '@/components/index.vue'
import Nav from '@/components/nav'
import Map from '@/components/map'
import Banner from '@/components/banner.vue'
export default {
  name: 'Index',
  components: {
    Nav,
    Map,
    Banner
  },
  data() {
    return {
      navData: ['首页', '公司简介','产品介绍', '产品流程', '联系我们'],
      // navIndex: 0,
      offsetTopArr: []
    }
  },
  methods: {
    goTryPro() {
      const top = document.querySelector('.contactUs').getBoundingClientRect().top
      document.body.scrollTop = top
      document.documentElement.scrollTop = top
    },
    goTaking(val) {
      this.$refs.nav.navClick(val)
    }
  }
}
</script>

<style scoped>
  img{
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .nav-center img{width: 118px;height: 36px;}
  .nav-list{display: flex;align-items: center;color: #fff;font-size: 14px;position: relative;}
  .nav-item{width:80px;display: flex;flex-direction: column;justify-content: center;align-items: center;line-height: 70px;position: relative;z-index: 1000;}
  /* .nav-item:hover{border-bottom: 3px solid #0092dd} */
  .nav-border{background: #01A7EB;height: 70px;width: 80px;position: absolute;left: 0;top: 0;transition: left 0.3s ease;}
  .title-banner{left: 0;top: 0;width: 100%;}
  .content{position: relative;}
  .content img{width: 100%;}
  .footer{position: relative;display: flex;justify-content: center;align-items: center;background: rgba(20,26,34,0.90);height: 60px;}
  .record-number{position: absolute;color: #fff;font-size: 14px;}

  .introduction{height: 840px;display: flex;align-items: center;flex-direction: column;width: 100%;overflow: hidden;}
  .database{height: 600px;display: flex;justify-content: center;align-items: center;flex-direction: column;color: #fff;position: relative;overflow: hidden;}
  
  .database img{transition: all 1s ease-in-out;}
  .database:hover img{transform: scale(1.1);}
  .database-ch{margin-bottom: 20px;font-family: SourceHanSansCN-Bold;font-size: 36px;letter-spacing: 6px;}
  .database-en{font-family: SourceHanSansCN-Regular;font-size: 14px;letter-spacing: 2.63px;text-transform:uppercase}

  .content-title{width: 100%;text-align: center;display: flex;justify-content: center;align-items: center;flex-direction: column;padding-top: 88px;}
  .content-title .title-dot{width: 40px;display: flex;justify-content: space-between;margin-top: 14px;}
  .content-title .title-dot span{display: block;width: 8px;height: 8px;background:#01A7EB;border-radius: 50%;}
  .content-title .title-ch{font-family: PingFangSC-Semibold; font-size: 36px; color: #333333;}
  .content-title .title-en{font-family: SourceHanSansCN-Regular;font-size: 24px;color: #999999;text-transform:uppercase}

  .service{height: 840px;background: #F8F8FA;}
  .card-list{height: 450px;display: flex;margin-top: 90px;width: 100%;text-align: center;justify-content: center;}
  .card-item{height: 100%;width: 280px;font-family: PingFangSC-Regular;font-size: 18px;color: #666666;letter-spacing: 0;line-height: 30px;background: #fff;border-radius: 10px;overflow: hidden;}
  .card-item:nth-child(2){margin-left: 20px;}
  .card-item:nth-child(3){margin: 0 20px;}
  .card-item img{transition: all 1s ease;}
  .card-item:hover img{transform: scale(1.15);}
  .card-img{overflow: hidden;}

  .card-text{padding: 40px 24px;text-align: justify;}
  

  .contactUs{height: 1318px;}

  .company-img{list-style: none;display: flex;margin-top: 100px;}
  .company-img li img{width: 500px;height: 280px;}
  .company-img li:nth-child(2){margin: -50px -200px 0;z-index: 1;}
  .company-img li:nth-child(1), li:last-child{opacity: 0.8;}
  .company-img li{transition: all 1s ease;}
  .company-img li:hover{z-index: 9;opacity: 1;}
  .company-text{width: 900px;font-size: 16px;color: #666666;line-height: 24px;}
  .company-text li{margin-top: 20px;list-style: square;}
  .company-text li:last-child{list-style: none;}

  .boxItem{position: relative;}
  .boxItem-bj{position: absolute;left: 0;top: 0;z-index: -1;display: block;}

  .contact-view{height: 260px;width: 100%;background: #01A7EB;color: #fff;display: flex;justify-content: center;margin:90px 0;}

  .contact-view ul{display: flex;flex-direction: column;align-items: center;width: 252px;margin-top: 50px;}
  .contact-view ul li{list-style: none;}
  .contact-view ul li:nth-child(2){margin-top: 10px;font-family: MicrosoftYaHei;font-size: 20px;}
  .contact-view ul li:nth-child(3){width: 40px;border-bottom: 4px solid #fff;margin: 10px 0 20px 0;}
  .contact-view ul li:last-child{font-family: MicrosoftYaHei;font-size: 18px;color: #FFFFFF;text-align: center;}
  .contact-view img{height: 37px;width: 29px;}
  /* .header{transform-style: preserve-3d;  animation: run 1s forwards; }

  @keyframes run {
    0% { transform: rotateZ(10deg); }
    100% { transform: rotateZ(0deg); }
  } */

  /* img{ animation: Opacity 1s forwards }
  @keyframes Opacity {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  @-webkit-keyframes Opacity {
    from { opacity: 0; }
    to { opacity: 1; }
  } */
</style>



// WEBPACK FOOTER //
// src/view/index.vue